import FileButtonOptions from '../../../../components/common/fileButtonOption';
import { getSafeImageUrl } from '../../../../utils/securityUtil';

const imageCardClasses =
  'group rounded-lg p-2.5 bg-white text-center relative ' +
  'transition-[transform,box-shadow] duration-300 ease-in-out ' +
  'shadow-signature-card z-[1] mb-2 max-w-[calc(var(--spacing)*105)]';

const hoverActionIconsClasses =
  'hidden group-hover:[display:unset] absolute right-4 top-5 ' +
  '[&_button]:w-10 [&_button]:h-10 [&_button]:shadow-signature-action';

const imageClasses =
  'w-full max-h-40 object-contain rounded ' +
  'bg-[repeating-conic-gradient(var(--color-surface-alt)_0%_25%,var(--color-white)_0%_50%)] ' +
  'bg-[length:calc(var(--spacing)*4)_calc(var(--spacing)*4)]';

const SignaturePreviewCard = ({ signature, isUploading, onDownload, onRemove }) => (
  <div className={imageCardClasses}>
    <img
      src={getSafeImageUrl(signature.viewUrl, '/placeholder.png')}
      alt="Current planner signature"
      className={imageClasses}
    />
    <FileButtonOptions
      divClassName={hoverActionIconsClasses}
      onDownload={onDownload}
      onDelete={onRemove}
      isLoading={isUploading}
    />
  </div>
);

export default SignaturePreviewCard;
